export const cloneDeep = value => JSON.parse(JSON.stringify(value));

export const get = (object = {}, key, defaultValue) => {
  if (Object.prototype.hasOwnProperty.call(object, key)) {
    return object[key];
  }
  return defaultValue;
};

const MapMBTIDimension = type => {
  switch (type) {
    case '1':
      return 'I';
    case '2':
      return 'E';
    case '3':
      return 'N';
    case '4':
      return 'S';
    case '5':
      return 'T';
    case '6':
      return 'F';
    case '7':
      return 'P';
    case '8':
      return 'J';
    default:
      return '';
  }
};

export const replaceValue = (answerObject, data, index) => {
  let answer = '';
  if (index === 1) {
    answer = answerObject?.lastValue;
  } else {
    answer = answerObject?.firstValue;
  }
  return {
    id: data.id,
    mbti_personal_style: MapMBTIDimension(data.mbti_personal_style),
    question: data.question.replace('_____', `__${answer}__`).substring(0, 9),
    answer
  };
};

export const compare = (data, a, b) => {
  if (data[a] > data[b]) {
    return a;
  }
  return b;
};

export const mbtiAnswer = {
  I: [],
  E: [],
  N: [],
  S: [],
  T: [],
  F: [],
  P: [],
  J: []
};

export const dateFormat = (dateString) => {
  const date = new Date(dateString);
  return date.toLocaleString();
};
